import './Switch.scss';
import { ChangeEvent, useCallback, useState } from 'react';

export type SwitchInterface = {
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
};

const Switch = ({ onChange = () => {} }: SwitchInterface) => {
  const [checked, setChecked] = useState(false);

  const onChangeCallback = useCallback((e) => {
    const newValue = e.target.checked;
    onChange(newValue);
    setChecked(newValue);
  }, []);

  return (
    <div className="visibilty-switch hmf-display-flex">
      <div className="switch">
        <input type="checkbox" onChange={onChangeCallback} />
        <span className={`slider round ${checked ? 'active' : ''}`} />
      </div>
    </div>
  );
};

export default Switch;
